import { render, staticRenderFns } from "./ShippingOrder.vue?vue&type=template&id=3b63a271&scoped=true&"
import script from "./ShippingOrder.vue?vue&type=script&lang=js&"
export * from "./ShippingOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShippingOrder.vue?vue&type=style&index=0&id=3b63a271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63a271",
  null
  
)

export default component.exports